jQuery(function($) {

  var body = $('body');

  function windowSize() {
    windowHeight = window.innerHeight ? window.innerHeight : $(window).height();
    windowWidth = window.innerWidth ? window.innerWidth : $(window).width();
  }

  var activeMenu = function() {
    body.addClass('menu-active');
  }

  var inactiveMenu = function() {
    body.removeClass('menu-active');
  }

  var activeSearch = function() {
    body.addClass('search-active');

    // run this after css transition has ended
    $('.search').one('webkitTransitionEnd otransitionend oTransitionEnd msTransitionEnd transitionend',
      function(e) {
        $('.search__input').focus();
      });
  }

  var inactiveSearch = function() {
    body.removeClass('search-active');
  }

  var activeModal = function() {
    body.addClass('modal-active');
  }

  var inactiveModal = function() {
    body.removeClass('modal-active');
  }

  var toggleModal = function(e) {
    if (body.hasClass('modal-active')) {
      inactiveModal();
    }
    else {
      activeModal();
    }
  }

  var toggleMenu = function() {
    if (body.hasClass('menu-active')) {
      inactiveMenu();
    }
    else {
      activeMenu();
      inactiveSearch();
    }
  }

  var toggleSearch = function() {
    if (body.hasClass('search-active')) {
      inactiveSearch();
    }
    else {
      activeSearch();
      inactiveMenu();
    }
  }

  $('.header__search__icon').on('click', toggleSearch);
  $('.search__close--icon').on('click', toggleSearch);
  $('.header__menu__button').on('click', toggleMenu);
  $('.header__menu__button__close--icon').on('click', toggleMenu);
  $('[data-modal-download]').on('click', toggleModal);
  $('[data-modal-login]').on('click', toggleModal);
  $('[data-modal-register]').on('click', toggleModal);
  $('[data-modal-confirm]').on('click', toggleModal);
  $('a.modal__close').on('click', toggleModal);

  $(window).on('resize', function() {
    if($(window).width() > 1024) {
      inactiveMenu();
    }
  });

  $(document).mouseup(function (e) {
    var container = $('.search');

    if (!container.is(e.target) // if the target of the click isn't the container...
      && container.has(e.target).length === 0) { // ... nor a descendant of the container
        if(!$(e.target).hasClass('header__search__icon--close')) {
          inactiveSearch();
        }
    }
  });

  $(document).mouseup(function (e) {
    var container = $('.primary__navigation');

    if (!container.is(e.target) // if the target of the click isn't the container...
      && container.has(e.target).length === 0) { // ... nor a descendant of the container
        if(!$(e.target).hasClass('header__menu__button__icon--close')) {
          inactiveMenu();
        }
    }
  });
});
